import { render, staticRenderFns } from "./ViewReportSaleSoFar.vue?vue&type=template&id=1d1897f8&scoped=true"
import script from "./ViewReportSaleSoFar.vue?vue&type=script&lang=ts"
export * from "./ViewReportSaleSoFar.vue?vue&type=script&lang=ts"
import style0 from "./ViewReportSaleSoFar.vue?vue&type=style&index=0&id=1d1897f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1897f8",
  null
  
)

export default component.exports